(function () {
    'use strict';

    angular
        .module('travelExpenses')
        .controller('ClientCreditsDetailModalController', ClientCreditsDetailModalController);

        ClientCreditsDetailModalController.$inject = ['$uibModalInstance', 'credit', 'toastr'];

    function ClientCreditsDetailModalController($uibModalInstance, credit, toastr) {
        var vm = this;

        vm.credit       = credit;
        vm.formatDate   = formatDate;
        vm.ok           = ok;
        vm.cancel       = cancel;

        function formatDate(date) {
            return moment(date).format('DD/MM/YYYY');
        }

        activate();

        function activate() {
        }

        function ok () {
            // let query = {};
            // query['seller_id'] = vm.sellerSelected;
            // query['expo_id'] = vm.expoSelected;
            // query['currency'] = vm.currencySelected;
            // query['amount'] = vm.amount;
            // query['days'] = vm.days;
            // TravelExpenseService.saveDailyAllowance(query).then(function(response, status) {
            //     if(response.status !== 200) {
            //         toastr.error("An error ocurred on save this daily allowance");
            //     } else {
            //         toastr.success("Daily allowance successfully saved!");
            //         dailyAllowanceController.getByFilter();
            //     }
            //     $uibModalInstance.close();
            // }).catch(function(err) {
            //     toastr.error('Error:'+err);
            // });
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }
    }
})();